// extracted by mini-css-extract-plugin
export var bannerContainer = "bannerComponent-module--bannerContainer--d914d";
export var contentContainer = "bannerComponent-module--contentContainer--8677d";
export var image = "bannerComponent-module--image--cbce5";
export var subtitle = "bannerComponent-module--subtitle--63527";
export var title = "bannerComponent-module--title--d4c1f";